import {
  ApiInfo,
  ApiInfoPerType,
  CollectionActionTypesBag,
  NodeType,
  SingleActionTypesBag,
  StoreActionTypes,
  StoreNode,
  StoreStructure,
} from '../types/types';
import { toSingularAction } from './singular';
import { analyzeStructure, nodeToType } from './structure';

// ============== single ==============
export const single_actionTypes = (nodeName: string): SingleActionTypesBag => {
  return {
    get: `GET_${nodeName.toUpperCase()}`,
    setAll: `SET_${nodeName.toUpperCase()}`,
    patch: `PATCH_${nodeName.toUpperCase()}`,
  };
};

// ============== collection ==============
export const collection_actionTypes = (nodeName: string): CollectionActionTypesBag => {
  return {
    get: `GET_${nodeName.toUpperCase()}`,
    setAll: `SET_${nodeName.toUpperCase()}`,
    set: `SET_${toSingularAction(nodeName)}_ITEM`,
    add: `ADD_${toSingularAction(nodeName)}_ITEM`,
    patch: `PATCH_${toSingularAction(nodeName)}_ITEM`,
    delete: `DELETE_${toSingularAction(nodeName)}_ITEM`,
    merge: `MERGE_${nodeName.toUpperCase()}`,
  };
};

// ============== from store structure ==============
export const generateActionTypesForStore = <T extends StoreStructure>(
  storeState: T
): StoreActionTypes<T> => {
  let output = {} as StoreActionTypes<T>;

  const keys: Array<keyof T> = Object.keys(storeState);

  for (const key of keys) {
    const value: StoreNode = storeState[key];
    const type = nodeToType(value);

    switch (type) {
      case NodeType.SINGLE_NODE:
        output[key] = single_actionTypes(String(key)) as any;
        break;
      case NodeType.COLLECTION_NODE:
        output[key] = collection_actionTypes(String(key)) as any;
        break;
    }
  }

  return output;
};

const GET_VERBS = ['get'];
const LOCAL_VERBS = ['setAll', 'set'];

export const generateActionTypesDictionaryForStore = <T extends StoreStructure>(
  storeState: T
): ApiInfoPerType => {
  let output = {} as ApiInfoPerType;

  const storeActionTypes = generateActionTypesForStore(storeState);
  const structure = analyzeStructure(storeState);

  const nodeKeys: Array<keyof T> = Object.keys(storeActionTypes);

  for (const nodeName of nodeKeys) {
    const bag = storeActionTypes[nodeName] as any;
    const nodeType = (structure as any)[nodeName];

    Object.keys(bag).forEach((apiVerb: any) => {
      const actionType = bag[apiVerb];
      output[actionType] = {
        id: actionType,
        verb: apiVerb,
        nodeName,
        nodeType,
      } as ApiInfo;

      if (LOCAL_VERBS.includes(apiVerb)) {
        output[actionType].isLocal = true;
      }

      if (GET_VERBS.includes(apiVerb)) {
        output[actionType].isGet = true;
      }
    });
  }

  return output;
};
